import { render, staticRenderFns } from "./image-editor.vue?vue&type=template&id=7d630f48"
import script from "./image-editor.vue?vue&type=script&lang=ts"
export * from "./image-editor.vue?vue&type=script&lang=ts"
import style0 from "./image-editor.vue?vue&type=style&index=0&id=7d630f48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports